import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

export const customFieldFormFieldStyles = css`
  width: 100%;
  margin-bottom: 10px;

  label > span {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const customFieldInputStyles = css`
  margin-bottom: 0;

  input {
    border: none;
    padding: 4px 0;
    color: var(${DesignToken.ContentBasicPrimary});
  }
  
  input::placeholder {
    color: var(${DesignToken.ContentBasicDisabled});
    opacity: 1;
  }
  
  input:disabled {
    opacity: 1;
  }
  
  input:focus {
    padding: 8px 10px;
    border: 1px solid var(${DesignToken.ActionPrimaryDefault});
  }
`;

export const customFieldButtonStyles = css`
  font-size: 14px;

  &:hover,
  &:active {
    text-decoration: none;
  }
`;
